import React from "react";

export default function Footer() {
  return (
    <footer className="w-full text-center py-12 bg-black text-white text-xs text-opacity-50 relative">
      <a
        href="https://github.com/metkerr"
        target="_blank"
        rel="noopener noreferrer"
        className="hover:underline"
      >
        Design & Crafted by Gusti &copy; 2022 All rights reserved
      </a>
    </footer>
  );
}
